// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22acb","rightAdornment":"Header_rightAdornment__3qCRa"};